import {Floor, EntityType} from "./Model";
import {EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {officeArrayResource} from "./CurrentOfficeStore";
import {Floors_Read} from "../util/access/Permission";

export const useFloorStore = create<EntityStore<Floor[]>>()(
    officeArrayResource<Floor, EntityStore<Floor[]>>(EntityType.Floors, builder => {
        const rest = builder.crud('/floors', 'id');

        return {
            remoteValue: builder.all(Floors_Read, () => rest.getAll()),
        };
    })
);

startEntityStore(useFloorStore);
